import { createApi } from "@reduxjs/toolkit/dist/query/react";
import customBaseQuery from "./custom.base-query";

type TLoginRequest = {
  address: string;
  signature: string;
};

type TLoginResponse = {
  accessToken: string;
};

const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // registerReferral: builder.mutation<
    //   null,
    //   Pick<TReferral, "address" | "value"> & Pick<TReferrer, "id">
    // >({
    //   query: ({ id, address, value }) => ({
    //     url: `/${id}/referrals`,
    //     method: "POST",
    //     body: { address, value },
    //   }),
    // }),
    getNonce: builder.query<
      {
        nonce: number;
      },
      string
    >({
      query: (address) => ({
        url: "auth/nonce",
        method: "GET",
        params: {
          address,
        },
      }),
    }),
    login: builder.mutation<TLoginResponse, TLoginRequest>({
      query: (args) => ({
        url: "auth/login",
        method: "POST",
        body: args,
      }),
    }),
  }),
});

export const { useLazyGetNonceQuery, useLoginMutation } = authApi;

export default authApi;
